// extracted by mini-css-extract-plugin
export default {"label":"radio_label__f-djM","button":"radio_button__-PG6z","buttonActive":"radio_buttonActive__t+13E","disable":"radio_disable__L5rUZ"};